import { render, staticRenderFns } from "./Vehicles.vue?vue&type=template&id=87fba4fe&"
import script from "./Vehicles.vue?vue&type=script&lang=js&"
export * from "./Vehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87fba4fe')) {
      api.createRecord('87fba4fe', component.options)
    } else {
      api.reload('87fba4fe', component.options)
    }
    module.hot.accept("./Vehicles.vue?vue&type=template&id=87fba4fe&", function () {
      api.rerender('87fba4fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Vehicles.vue"
export default component.exports